var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurso(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.232,
    height: 23.174,
    viewBox: "0 0 33.232 23.174",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_361",
    "data-name": "Rect\\xE1ngulo 361",
    width: 33.232,
    height: 23.174,
    fill: "#f49a3f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19",
    "data-name": "Grupo 19",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10",
    "data-name": "Grupo 10",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_32",
    "data-name": "Trazado 32",
    d: "M37.372.01c-.03,0-.123.013-.208.022A5.6,5.6,0,0,0,35.476.5,18,18,0,0,1,29.519,1.94l-.351.009V20.513H29.2c.061,0,.58-.063.922-.111a25.73,25.73,0,0,0,5.351-1.333,5.343,5.343,0,0,1,1.618-.408,12.514,12.514,0,0,1,6.4,1.72c.131.072.245.131.249.131s.01-4.179.01-9.284V1.946l-.212-.13A12.546,12.546,0,0,0,38.683.038c-.2-.024-1.164-.045-1.312-.028m12.476,0-.223.022a12.658,12.658,0,0,0-5.071,1.858l-.072.045v9.289c0,5.109.006,9.288.012,9.285l.263-.142a12.881,12.881,0,0,1,5.955-1.717,4.815,4.815,0,0,1,1.966.391A25.22,25.22,0,0,0,57.451,20.3c.583.1,1.44.211,1.581.211h.039V1.949l-.366-.01A18.014,18.014,0,0,1,52.763.506,5.757,5.757,0,0,0,51.128.038C50.961.014,50-.006,49.848.01M28.366,3.071c-.064.006-.308.016-.544.022l-.427.012V23.15h.066c.1,0,.844-.087,1.276-.148A30.4,30.4,0,0,0,34.6,21.589a6.24,6.24,0,0,1,2.238-.454,15.374,15.374,0,0,1,6.778,1.824c.209.1.384.191.388.191s.227-.108.493-.238a13.931,13.931,0,0,1,7.4-1.723,6.3,6.3,0,0,1,1.527.4,30.364,30.364,0,0,0,5.806,1.4c.517.075,1.221.157,1.337.157h.06V3.1h-.282c-.254,0-.39-.007-.817-.04l-.134-.01V21.129h-.058c-.227,0-1.46-.169-2.239-.308a26.957,26.957,0,0,1-4.442-1.165,5.942,5.942,0,0,0-.983-.284c-1.891-.36-4.576.217-7.267,1.56l-.393.2-.432-.214a12.819,12.819,0,0,0-6.956-1.587,5.336,5.336,0,0,0-1.241.324,28.944,28.944,0,0,1-6.614,1.472l-.142.01V3.055l-.073,0c-.04,0-.124.007-.188.013",
    transform: "translate(-27.395 0.001)",
    fill: "#f49a3f",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurso);
export default __webpack_public_path__ + "static/media/curso.e8c2d51c6a7812f5d4de7bfdcc787372.svg";
export { ForwardRef as ReactComponent };